import * as React from "react";
import { useSearchParams } from "react-router";

import { EventRecord } from "@/shared/domain/events";
import { SearchParams } from "@/shared/environment";
import { nanoSecToSecStr } from "@/shared/time";

import {
  SidebarTab,
  SidebarViewType,
  useWorkspaceSidebar,
} from "../../sidebarContext";

/**
 * Show a topic an event is about: filter the sidebar's Topics tab to the
 * topic's name and seek the workspace to the event's start.
 */
export function useViewTopic() {
  const sidebar = useWorkspaceSidebar();
  const [_, setSearchParams] = useSearchParams();

  return React.useCallback(
    function viewTopic(topicName: string, event: EventRecord) {
      sidebar.openView({
        type: SidebarViewType.TabbedSidebar,
        data: {
          initialTopicFilter: {
            term: topicName,
            key: Date.now(), // Unique key for command semantics
          },
        },
      });
      sidebar.setActiveTab(SidebarTab.Topics);

      setSearchParams(
        (oldParams) => {
          const params = new URLSearchParams(oldParams);
          params.set(SearchParams.TIMESTAMP, nanoSecToSecStr(event.start_time));
          return params;
        },
        { replace: true },
      );
    },
    [sidebar, setSearchParams],
  );
}
